import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class ProjectService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/projects', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/project/{id}', { id: id }), params);
	}
}


